import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProjectProvider } from "@/context/ProjectContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ProjekKamar from "@/pages/ProjekKamar";
import Penghuni from "@/pages/Penghuni";
import BookingSewa from "@/pages/BookingSewa";
import Pembayaran from "@/pages/Pembayaran";
import GuestHouse from "@/pages/GuestHouse";
import InvestorLaporan from "@/pages/InvestorLaporan";
import AngsuranInvestor from "@/pages/AngsuranInvestor";
import RekapKeuangan from "@/pages/RekapKeuangan";
import Persetujuan from "@/pages/Persetujuan";
import PencairanInvestor from "@/pages/PencairanInvestor";
import KeuanganOperasional from "@/pages/KeuanganOperasional";
import RiwayatDeposit from "@/pages/RiwayatDeposit";
import Pengaturan from "@/pages/Pengaturan";
import Parkir from "@/pages/Parkir";

function Shell() {
  return (
    <ProjectProvider>
      <AppLayout />
    </ProjectProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Shell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/proyek-kamar" element={<ProjekKamar />} />
            <Route path="/penghuni" element={<Penghuni />} />
            <Route path="/booking-sewa" element={<BookingSewa />} />
            <Route path="/pembayaran" element={<Pembayaran />} />
            <Route path="/riwayat-deposit" element={<RiwayatDeposit />} />
            <Route path="/guest-house" element={<GuestHouse />} />
            <Route path="/parkir" element={<Parkir />} />
            <Route path="/investor-laporan" element={<InvestorLaporan />} />
            <Route path="/angsuran-investor" element={<AngsuranInvestor />} />
            <Route path="/rekap-keuangan" element={<RekapKeuangan />} />
            <Route
              path="/persetujuan"
              element={
                <ProtectedRoute superadminOnly>
                  <Persetujuan />
                </ProtectedRoute>
              }
            />
            <Route path="/pencairan-investor" element={<PencairanInvestor />} />
            <Route
              path="/keuangan-operasional"
              element={
                <ProtectedRoute superadminOnly>
                  <KeuanganOperasional />
                </ProtectedRoute>
              }
            />
            <Route path="/pengaturan" element={<Pengaturan />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
